import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { beforeItems, afterItems } from "../data/content";
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-40" data-mp="3ofhx3ds4fjys">
      <div className="mx-auto max-w-5xl" data-id="element-41" data-mp="3sgbju3ttusq3">
        <SectionHeading kicker="A More Structured Way to Approach CAN Bus Faults" title="From scattered information and uncertain next steps… to a repeatable diagnostic workflow." subtitle="When you're investigating a communication problem, having more information doesn't always make the next decision easier. What you need is a way to organize that information." data-id="element-42" data-mp="3sjfu9ixvykp7" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-43" data-mp="39oiqu9erd7id">
          <div className="rounded-3xl border-2 border-alert/30 bg-alert-light/60 p-6 sm:p-8" data-id="element-44" data-mp="2vsezqoz6lfa4">
            <div className="flex items-center gap-3" data-id="element-45" data-mp="30p5ffb72q8v0">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-alert text-white" data-id="element-46" data-mp="x4k3cz82pw6a">
                <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-47" data-mp="t38krdnmab7l" />
              </span>
              <h3 className="font-display text-2xl font-extrabold text-alert" data-id="element-48" data-mp="t5bcq38byeey">Before the Blueprint</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-49" data-mp="12354d0v5gjvs">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-50" data-mp="edsya9v4crxp">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-51" data-mp="9ezjme43iuvy" />
                  <span data-id="element-52" data-mp="9d4x4vd6eupr">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/40 bg-[#E8F7EE] p-6 sm:p-8" data-id="element-53" data-mp="jd5isnyipmx4">
            <div className="flex items-center gap-3" data-id="element-54" data-mp="jbcal489aun0">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white" data-id="element-55" data-mp="3rrxe45i4cviq">
                <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-56" data-mp="3mt2wh6vw1d07" />
              </span>
              <h3 className="font-display text-2xl font-extrabold text-cta-dark" data-id="element-57" data-mp="1qpofu5vk4tlj">With the Blueprint</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-58" data-mp="1vo9fo46wdb9g">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-59" data-mp="20hu352av6mue">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-60" data-mp="24h30eh5452up" />
                  <span data-id="element-61" data-mp="17swwxxjxggi0">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-62" data-mp="1crhyq1etv88k">
          The goal isn't to replace your technical expertise. It's to give your expertise a{" "}
          <span className="text-brand" data-id="element-63" data-mp="1lpjvu5vfxgqk">clearer structure.</span>
        </p>

        <div className="mt-8" data-id="element-64" data-mp="2s76yya3g2ceu">
          <CtaButton label="Yes! Show me the system" arrow data-id="element-65" data-mp="2sa2w3w7gwx28" />
        </div>
      </div>
    </section>;
}